import {
  createValidation,
  validatorMaxLength,
  validatorRequired,
} from '../../utils/formValidators';
import { disseminationLevel } from '../../constants/parameters';

export default createValidation([
  {
    name: disseminationLevel.CODE,
    validators: [validatorRequired(), validatorMaxLength(3)],
  },
  {
    name: `${disseminationLevel.LANG}.${disseminationLevel.ESTONIAN}`,
    validators: validatorRequired(),
  },
  {
    name: `${disseminationLevel.LANG}.${disseminationLevel.ENGLISH}`,
    validators: [validatorRequired()],
  },
]);
